import React, { useEffect, useState } from "react";
import RolesList from "../../components/Roles/RolesList";
import RolesFormModal from "../../components/Roles/RolesFormModal";
import AddRolesModal from "../../components/Roles/AddRolesModal";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Button from "sushiweb/Button";
import FilterButton from "../../components/Common/FilterButton";
import styled from "styled-components";
import * as RolesActions from "../../store/actions/Roles";
import { Heading } from "../../constants/assets/containers";
import { isMobile } from "../../utils";

const Roles = (props) => {
  const { getRolesList, rolesList, getRolesActions, activeFilters } = props;
  const [modalState, setModalState] = useState("");

  const handleClick = (type, item) => {
    item && getRolesActions(item.id, item.name);
    setModalState(type);
  };

  const handleClose = () => {
    setModalState("");
  };

  useEffect(() => {
    getRolesList();
  }, []);

  const getModal = () => {
    switch (modalState) {
      case "Filter":
        return (
          <RolesFormModal
            heading="Filter Roles"
            modalState={modalState}
            handleClose={handleClose}
          />
        );
      case "Edit":
        return (
          <RolesFormModal
            heading="Manage Roles"
            modalState={modalState}
            handleClose={handleClose}
          />
        );
      case "AddRoles":
        return (
          <AddRolesModal
            heading="Assign Action to Roles"
            modalState={modalState}
            handleClose={handleClose}
          />
        );
      default:
        return (
          <RolesFormModal
            heading="Manage Roles"
            modalState={modalState}
            handleClose={handleClose}
          />
        );
    }
  };

  return (
    <RolesViewContainer className="roles-view">
      <div id="roles-holder" className="flex mb-20 justify-between">
        <Heading>Role Management Dashboard</Heading>
        <div
          style={{ maxWidth: "340px" }}
          className="actionBar mb-20 flex items-center justify-between"
        >
          <FilterButton
            activeFilters={activeFilters}
            handleClick={handleClick}
          />
          <Button
            onClick={() => handleClick("AddRoles", null)}
            className="sushi-btn ml-20"
          >
            Assign action to roles
          </Button>
        </div>
      </div>
      <RolesList handleClick={handleClick} rolesList={rolesList} />
      {modalState && getModal()}
    </RolesViewContainer>
  );
};

const RolesViewContainer = styled.div`
  #roles-holder {
    flex-direction: ${isMobile() ? "column" : "row"};
  }
  .actionBar {
    margin-left: ${isMobile() ? "unset" : "auto"};
    margin-top: ${isMobile() ? "10px" : "unset"};
  }
`;

function mapStateToProps(state) {
  const { Roles } = state;
  return {
    rolesList: Roles.rolesList,
    activeFilters: Roles.activeFilters,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getRolesList: bindActionCreators(RolesActions.getRolesList, dispatch),
    getRolesActions: bindActionCreators(RolesActions.getRolesActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Roles);
